import React from "react";
import { trpc } from "../lib/trpc";
import { Video as VideoIcon } from "lucide-react";

interface Props {
  videoId: number;
  token: string;
  alt?: string;
  className?: string;
}

export function PublicVideoThumbnail({ videoId, token, alt = "", className = "w-full h-full object-cover" }: Props) {
  const { data, isLoading } = trpc.gallery.getVideoThumbnailUrl.useQuery({ videoId, token }, { enabled: !!videoId && !!token });

  if (isLoading) {
    return (
      <div className="w-full h-full bg-muted flex items-center justify-center">
        <VideoIcon className="h-6 w-6 text-muted-foreground" />
      </div>
    );
  }

  if (data?.url) {
    return <img src={data.url} alt={alt} className={className} loading="lazy" />;
  }

  return (
    <div className="w-full h-full bg-muted flex items-center justify-center">
      <VideoIcon className="h-6 w-6 text-muted-foreground" />
    </div>
  );
}
